import { get } from "./api.service";

const base_url = "dashboard/v1";

const buildQueryString = (params: any) => {
  if (!params) return "";
  const filteredParams = Object.fromEntries(
    Object.entries(params)
      .filter(([_, v]) => v !== null && v !== undefined && v !== "")
      .map(([k, v]) => [k, String(v)])
  );
  const queryString = new URLSearchParams(filteredParams).toString();
  return queryString ? `?${queryString}` : "";
};

export const getKpis = (params?: any) => {
  return get(`${base_url}/kpis${buildQueryString(params)}`);
};

export const getRevenue = (params: any = { months: 12 }) => {
  return get(`${base_url}/revenue${buildQueryString(params)}`);
};

export const getOverdueCollections = (params?: any) => {
  return get(`${base_url}/overdue-collections${buildQueryString(params)}`);
};

export const getContractsTimeline = (months: number = 12) => get(`${base_url}/contracts-timeline?months=${months}`);

export const getRevenueByPlan = (params?: any) => {
  return get(`${base_url}/revenue-by-plan${buildQueryString(params)}`);
};

export const getOneOffSales = (params?: any) => {
  return get(`${base_url}/one-off-sales${buildQueryString(params)}`);
};

export const getPlansWithDefault = () => get(`${base_url}/plans-with-default`);
